<template>
  <div class="sk-regulatory-wrapper">
    <slot></slot>
    <sk-regulatory-footer v-bind="{ userDevice }" />
  </div>
</template>

<script>
import Regulatory from './regulatory';
import SkRegulatoryFooter from './regulatoryFooter';

export default {
  name: 'SKRegulatory',
  mixins: [Regulatory],
  components: { SkRegulatoryFooter },
  props: { userDevice: { type: String, default: 'd' } }
}
</script>

<style lang="scss" scoped>
.sk-regulatory-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
</style>
